export const LIST_KEYS = {
  SELECTED_USERS: 'selected-users',
  SELECTED_PERSONS: 'selected-persons',
  ARCHIVING_PERSONS: 'archiving-persons',
} as const;

// Create a type from the registry values
export type ListKey = (typeof LIST_KEYS)[keyof typeof LIST_KEYS];

// Export individual keys for convenience
export const { SELECTED_USERS, SELECTED_PERSONS, ARCHIVING_PERSONS } = LIST_KEYS;
